import React, { useEffect, useState } from "react";

import HeaderWithIcon from "../../components/common/HeaderWithIcon";
import WithDrawRequestTabs from "./WithDrawRequestTabs";
import { withdrawalsApi } from "../../api/withdrawals";
import { useAuth } from "../../context/AuthContext";

export default function WithDrawRequest() {
  const { tokens } = useAuth();
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ 
    page: 1, 
    limit: 20, 
    total: 0, 
    status: "all"
  });

  const fetchWithdrawals = async () => {
    try {
      const { data } = await withdrawalsApi.getWithdrawals(tokens.access.token, {
        page: pagination.page,
        limit: pagination.limit,
        status: pagination.status === 'all' ? '' : pagination.status
      });
      setWithdrawals(data.rows);
      setPagination(prev => ({ ...prev, total: data.count }));
    } catch (error) {
      console.error("Failed to fetch withdrawals:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWithdrawals();
  }, [pagination.page, pagination.limit, pagination.status]); // Add status to dependencies

  // Updated tabs structure
  const tabsData = [
    {
      title: "Downline",
      cards: [
        { title: "All", status: "all" },
        { title: "Pending", status: "pending" },
        { title: "Approved", status: "approved" },
        { title: "Declined", status: "declined" } // Changed from 'rejected'
      ]
    }
  ];

  const handleStatusChange = (status) => {
    setPagination(prev => ({
      ...prev,
      page: 1, // Reset to first page when changing status
      status: status
    }));
  };

  const handlePageChange = (page) => {
    setPagination(prev => ({
      ...prev,
      page: page
    }));
  };

  const totalPages = Math.ceil(pagination.total / pagination.limit);

  return (
    <div className="min-h-screen relative overflow-hidden font-poppins">
      <HeaderWithIcon title="Withdrawal Request" />
      <WithDrawRequestTabs 
        tabsData={tabsData} 
        withdrawals={withdrawals}
        onStatusChange={fetchWithdrawals}
        currentStatus={pagination.status}
        handleStatusChange={handleStatusChange}
        pagination={{
          currentPage: pagination.page,
          totalPages: totalPages,
          onPageChange: handlePageChange
        }}
      />
    </div>
  );
}
